<template>
    <el-dialog
        style="padding: 0 20px 20px 20px !important;"
        width="80%"
        title="下载列表"
        :visible.sync="visible"
        :before-close="handleClose"
    >

        <el-button size="small" @click="getList" type="primary" style="margin:20px">刷新</el-button>

        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            border
            style="width: 100%"
        >
            <el-table-column label="ID" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" width="180" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time }}</div>
                </template>
            </el-table-column>

            <el-table-column label="生成时间" width="180" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.parse_time || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作"  align="center">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.status == 0" size="mini" style="margin: 5px 0 5px 10px">待生成</el-button>
                    <el-button v-if="scope.row.status == 1" size="mini" style="margin: 5px 0 5px 10px">生成中</el-button>
                    <el-button style="margin: 5px 0 5px 10px" type="success" v-if="scope.row.status == 2" @click="downFile(scope.row.parsing_path)" size="mini">下载</el-button>

                    <!--                    <el-button type="success"  size="mini" style="margin: 5px 0 5px 10px">生成完成</el-button>-->
<!--                    <el-button type="danger" v-if="scope.row.status == '-1'" size="mini" style="margin: 5px 0 5px 10px">生成失败</el-button>-->
                    <el-button type="danger" @click="showErrorInfo(scope.row)" v-if="scope.row.status == -1" size="mini" style="margin: 5px 0 5px 10px">查看失败原因</el-button>

<!--                    <el-button v-if="scope.row.status === -1" type="danger" size="mini"-->
<!--                               @click="showErrorInfo(scope.row)">查看完整错误信息</el-button>-->
<!--                    <el-button v-if="scope.row.status === 0" style="margin: 5px 0 5px 10px" type="success" size="mini"-->
<!--                               @click="startDecode(scope.row)">开始解析</el-button>-->
<!--                    <el-button v-if="scope.row.status === 2" style="margin: 5px 0 5px 10px" type="success"-->
<!--                               @click="downFile(scope.row.parsing_path)" size="mini">下载解析</el-button>-->
<!--                    <el-button v-if="scope.row.status !== 0 && scope.row.status !== 1" style="margin: 5px 0 5px 10px"-->
<!--                               type="success" size="mini" @click="startDecode(scope.row, 1)">重新解析</el-button>-->
<!--                    <el-button style="margin: 5px 0 5px 10px" type="danger" size="mini" @click="delete_file(scope.row)">-->
<!--                        删除</el-button>-->


                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :page-sizes="[10, 50, 100]"
                :total="query.total"
                background
                style="float: right;margin-top: 10px; margin-bottom: 5px"
                layout="total, sizes, prev, pager, next"
            >
            </el-pagination>
        </el-row>
        <el-dialog style="padding: 0 20px 20px 20px !important;" width="30%" center title="错误信息" v-if="errorInfoShow"
                   :visible.sync="errorInfoShow" append-to-body>
            <span style="color: red">错误内容：</span>
            <span>{{errorMsg}}</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
			</span>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/Product/Product'
    import {downloadFileUrl} from '@/utils/method'

    export default {
        name: 'uploadFileListDialog',
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            id: {
                type: Number,
                default: 0
            },
        },
        watch: {
            'visible': {
                handler(flag){
                    flag && this.getList()
                }
            }
        },
        data() {
            return {
                errorInfoShow: false,
                tableHeight: null,
                query: {
                    page: 1,
                    limit: 10,
                    state: '',
                    asgin: '',
                    ad_portfolio_name: '',
                    type: 'SB',
                },
                loading: false,
                errorMsg: '',
                currentId: '',
                ctrl: {
                    addRecordDialogVisible: false
                },
                list: [],
                rules: {
                    asin: [
                        {
                            required: true,
                            message: '请输入ASIN',
                            trigger: 'blur'
                        }
                    ],
                    state: [
                        {
                            required: true,
                            message: '请输入国家',
                            trigger: 'blur'
                        }
                    ],
                    ad_portfolio_name: [
                        {
                            required: true,
                            message: '请输入广告组合名称',
                            trigger: 'blur'
                        }
                    ],
                    type: [
                        {
                            required: true,
                            message: '请选择广告组类型',
                            trigger: 'blur'
                        }
                    ]
                },
                us_arr: [
                    {
                        us: 'US',
                        title: '美国'
                    },
                    {
                        us: 'UK',
                        title: '英国'
                    },
                    {
                        us: 'DE',
                        title: '德国'
                    }
                ],
            }
        },
        methods: {
            //查询
            onSubmit() {
                this.getList()
            },
            onReset() {
                this.$set(this, 'query', {type: 'SB'})
                this.query.page = 1
                this.query.limit = 20
                this.getList()
            },
            searchForm() {
                this.getList()
            },
            showErrorInfo(info) {
                this.errorInfoShow = true
                this.errorMsg = info.parsing_err_msg
            },
            getList() {
                this.loading = true
                api.compare_asin_download_excel_list({id: this.id, page: this.query.page, limit: this.query.limit}).then(res => {
                    if (res.code === 0) {
                        this.list = res.data.list
                        this.query.total = res.data.total
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.$emit('close-callback', isshow)
            },
            addRecords() {
                this.ctrl.addRecordDialogVisible = true
            },
            delete_records(data) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.out_three_page_delete({id: data.id}).then(() => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                })
            },
            closeCllback() {
                this.ctrl.addRecordDialogVisible = false
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            downFile(path) {
                if (!path) {
                    return this.$message({type: 'error', message: '无法下载！'})
                }
                downloadFileUrl(path)
            },
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ .el-card__header {
        padding: 14px 20px !important;
    }

    /deep/ .el-tabs__content {
        overflow: visible !important;
    }

    /deep/ .el-card {
        overflow: visible !important;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    .mini_div .el-button--mini {
        padding: 5px 5px !important;
    }

    /deep/ .el-table__expanded-cell {
        padding: 0 0 !important;
    }
</style>
